import { createReducer } from 'redux-act';
import * as actions from '#app/actions/category';

interface CategoryState {
  incomeModalVisible: boolean;
  spendingModalVisible: boolean;
  incomeForm: Record<string, unknown>;
  spendingForm: Record<string, unknown>;
  subcategoryModalVisible: boolean;
  subcategoryForm: Record<string, unknown>;
}

const initialState: CategoryState = {
  incomeModalVisible: false,
  spendingModalVisible: false,
  incomeForm: {},
  spendingForm: {},
  subcategoryModalVisible: false,
  subcategoryForm: {},
};

const setIncomeCategoryModalVisible = (state: CategoryState, bool: boolean): CategoryState => ({
  ...state,
  incomeModalVisible: bool,
});

const setIncomeCategoryForm = (
  state: CategoryState,
  form: Record<string, unknown>
): CategoryState => ({
  ...state,
  incomeForm: form,
});

const setSpendingCategoryModalVisible = (state: CategoryState, bool: boolean): CategoryState => ({
  ...state,
  spendingModalVisible: bool,
});

const setSpendingCategoryForm = (
  state: CategoryState,
  form: Record<string, unknown>
): CategoryState => ({
  ...state,
  spendingForm: form,
});

const setSubcategoryModalVisible = (state: CategoryState, bool: boolean): CategoryState => ({
  ...state,
  subcategoryModalVisible: bool,
});

const setSubcategoryForm = (
  state: CategoryState,
  form: Record<string, unknown>
): CategoryState => ({
  ...state,
  subcategoryForm: form,
});

export default createReducer<CategoryState>(
  {
    [actions.setIncomeCategoryModalVisible as any]: setIncomeCategoryModalVisible,
    [actions.setIncomeCategoryForm as any]: setIncomeCategoryForm,
    [actions.setSpendingCategoryModalVisible as any]: setSpendingCategoryModalVisible,
    [actions.setSpendingCategoryForm as any]: setSpendingCategoryForm,
    [actions.setSubcategoryModalVisible as any]: setSubcategoryModalVisible,
    [actions.setSubcategoryForm as any]: setSubcategoryForm,
  },
  initialState
);
